export const WORKFLOW_DATA_UPDATE = 'WORKFLOW_DATA_UPDATE';
export const CUSTOM_NODE = 'custom';
export const CUSTOM_EDGE = 'custom';
export const DSL_EXPORT_CHECK = 'DSL_EXPORT_CHECK';
export const DEFAULT_RETRY_MAX = 3;
export const DEFAULT_RETRY_INTERVAL = 100;

export enum NODE_TYPE {
  CUSTOM_NODE = 0,
  // 开始节点，定义对话入参
  START = 1,
  // LLM节点，大模型节点
  LLM,
  // 知识库节点
  KNOWLEDGE,
  // 条件节点
  CONDITION,
  // PG节点
  PG,
  // 结束节点
  END = 7,
}

export enum EDGE_TYPE {
  CUSTOM_EDGE,
}
export const NODE_TYPE_MAP = {
  [NODE_TYPE.CUSTOM_NODE]: 'CustomNode',
  [NODE_TYPE.START]: 'start',
  [NODE_TYPE.LLM]: 'llm',
  [NODE_TYPE.KNOWLEDGE]: 'knowledge',
  [NODE_TYPE.CONDITION]: 'condition',
  [NODE_TYPE.PG]: 'pg',
  [NODE_TYPE.END]: 'end',
};
